export const WIZARD_STEPS = {
    NAME_YOUR_AGENT: 1,
    WHITE_GLOVE_SERVICE: 2, // Keep for navigation but not in steps list
    CONFIRMATION: 3,
    CHATBOT_TEST: 4,
    USER_DETAILS: 5
};

export const STEP_TITLES = {
    [WIZARD_STEPS.NAME_YOUR_AGENT]: "Name Your Agent",
    [WIZARD_STEPS.WHITE_GLOVE_SERVICE]: "White Glove Service", // Keep for reference
    [WIZARD_STEPS.CONFIRMATION]: "Creating Agent",
    [WIZARD_STEPS.CHATBOT_TEST]: "Test Your Agent",
    [WIZARD_STEPS.USER_DETAILS]: "Go Live"
};
